// extracted by css-extract-rspack-plugin
export default {"cls1":"NewsHeader-cls1_HyY","cls2":"NewsHeader-cls2_kPJ NewsHeader-cls1_HyY"};